import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import Dialog, { DialogProps } from '@anm/components/modals/Dialog';
import Confirm, { ConfirmProps } from '@anm/components/notification/Confirm';
import { FC } from 'react';

const TEXT =
  'Streaming recording or videos which were streamed before cannot be edited directly. Please duplicate it first and edit the copy.';

type DuplicateStreamModalProps = Partial<ConfirmProps> &
  DialogProps & {
    isPending: boolean;
  };

const DuplicateStreamModal: FC<DuplicateStreamModalProps> = ({ isPending, onModalClose, onRightButtonClick }) => {
  const handleRightButtonClick = () => {
    onRightButtonClick?.();
    onModalClose?.();
  };

  return (
    <Dialog onModalClose={onModalClose} onSubmit={handleRightButtonClick}>
      <Confirm
        title="Edit video"
        buttonRight={{
          isPending,
          text: 'Duplicate to edit',
          size: 'upper-medium' as ButtonSize,
          variant: 'light-blue' as ButtonVariants
        }}
        buttonLeft={{
          isPending: false,
          text: 'Cancel',
          size: 'upper-medium' as ButtonSize,
          variant: 'blue-heavy-border' as ButtonVariants
        }}
        onLeftButtonClick={onModalClose}
        onRightButtonClick={handleRightButtonClick}
      >
        {TEXT}
      </Confirm>
    </Dialog>
  );
};

export default DuplicateStreamModal;
